(function () {
  if (window.SWCHighlightSystemLoaded) return;
  window.SWCHighlightSystemLoaded = true;

  var SOURCE_SELECTOR = '.swc-highlight-source[data-swc-highlight-rules]';
  var SKIP_SELECTOR = 'a, button, script, style, textarea, input, select, .swc-highlight';
  var idle = window.requestIdleCallback || function (callback) {
    return window.setTimeout(callback, 32);
  };

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function parseKeywordPart(keywordPart) {
    var keywords = [];
    var current = '';
    var inQuote = false;
    var quoteChars = '"“”';

    for (var index = 0; index < keywordPart.length; index++) {
      var character = keywordPart.charAt(index);
      var isQuote = quoteChars.indexOf(character) !== -1;

      if (isQuote) {
        if (inQuote) {
          var quotedWord = current.trim();
          if (quotedWord) keywords.push(quotedWord);
          current = '';
          inQuote = false;
        } else {
          if (current.trim()) keywords.push(current.trim());
          current = '';
          inQuote = true;
        }
        continue;
      }

      if (!inQuote && character === ',') {
        var word = current.trim();
        if (word) keywords.push(word);
        current = '';
        continue;
      }

      current += character;
    }

    var trailingWord = current.trim();
    if (trailingWord) keywords.push(trailingWord);

    return keywords;
  }

  function parseRules(rawRules) {
    if (!rawRules) return [];

    var byWord = new Map();
    rawRules.split(/\r?\n/).forEach(function (line) {
      var delimiterMatch = line.match(/\|\s*([1-5])\s*$/);
      if (!delimiterMatch) return;

      var style = parseInt(delimiterMatch[1], 10);
      if (!style || style < 1 || style > 5) return;

      var keywordPart = line.slice(0, delimiterMatch.index).trim();
      if (!keywordPart) return;

      parseKeywordPart(keywordPart).forEach(function (word) {
        var cleanWord = word.trim();
        if (!cleanWord) return;

        var key = cleanWord.toLocaleLowerCase();
        if (!byWord.has(key)) {
          byWord.set(key, {
            word: cleanWord,
            style: style
          });
        }
      });
    });

    return Array.from(byWord.values()).sort(function (a, b) {
      return b.word.length - a.word.length;
    });
  }

  function shouldSkipNode(node) {
    if (!node.nodeValue || !node.nodeValue.trim()) return true;
    var parent = node.parentElement;
    return !parent || parent.closest(SKIP_SELECTOR);
  }

  function highlightTextNode(node, regex, ruleMap) {
    var source = node.nodeValue;
    var match;
    var lastIndex = 0;
    var fragment = document.createDocumentFragment();
    var replaced = false;

    regex.lastIndex = 0;

    while ((match = regex.exec(source)) !== null) {
      var fullMatch = match[0];
      var prefix = match[1] || '';
      var word = match[2] || '';
      var wordStart = match.index + prefix.length;

      if (wordStart > lastIndex) {
        fragment.appendChild(document.createTextNode(source.slice(lastIndex, wordStart)));
      }

      var matchedRule = ruleMap[word.toLocaleLowerCase()];

      if (matchedRule) {
        var span = document.createElement('span');
        span.className = 'swc-highlight swc-highlight--' + matchedRule.style;
        span.textContent = source.slice(wordStart, wordStart + word.length);
        fragment.appendChild(span);
        replaced = true;
      } else {
        fragment.appendChild(document.createTextNode(word));
      }

      lastIndex = match.index + fullMatch.length;
    }

    if (!replaced) return;

    if (lastIndex < source.length) {
      fragment.appendChild(document.createTextNode(source.slice(lastIndex)));
    }

    node.parentNode.replaceChild(fragment, node);
  }

  function applyHighlights(source) {
    if (!source || source.dataset.swcHighlightApplied === 'true') return;

    var rules = parseRules(source.getAttribute('data-swc-highlight-rules'));
    if (!rules.length) {
      source.dataset.swcHighlightApplied = 'true';
      return;
    }

    var ruleMap = {};
    var pattern = rules.map(function (rule) {
      ruleMap[rule.word.toLocaleLowerCase()] = rule;
      return escapeRegExp(rule.word);
    }).join('|');

    if (!pattern) return;

    var regex = new RegExp('(^|[^A-Za-z0-9])(' + pattern + ')(?=$|[^A-Za-z0-9])', 'gi');
    var walker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      highlightTextNode(textNode, regex, ruleMap);
    });

    source.dataset.swcHighlightApplied = 'true';
  }

  function scheduleSource(source) {
    if (!source || source.dataset.swcHighlightQueued === 'true' || source.dataset.swcHighlightApplied === 'true') return;
    source.dataset.swcHighlightQueued = 'true';

    idle(function () {
      source.dataset.swcHighlightQueued = 'false';
      applyHighlights(source);
    });
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        scheduleSource(entry.target);
      });
    }, { rootMargin: '350px 0px' })
    : null;

  function registerSource(source) {
    if (!source || source.dataset.swcHighlightObserved === 'true' || source.dataset.swcHighlightApplied === 'true') return;
    source.dataset.swcHighlightObserved = 'true';

    if (observer) {
      observer.observe(source);
    } else {
      scheduleSource(source);
    }
  }

  function registerSources(root) {
    var scope = root || document;
    var sources = [];

    if (scope.matches && scope.matches(SOURCE_SELECTOR)) {
      sources.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll(SOURCE_SELECTOR), function (source) {
        sources.push(source);
      });
    }

    sources.forEach(registerSource);
  }

  function init() {
    registerSources(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    registerSources(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    registerSources(event.target);
    if (event.target && event.target.querySelectorAll) {
      Array.prototype.forEach.call(event.target.querySelectorAll(SOURCE_SELECTOR), scheduleSource);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var source = event.target && event.target.closest ? event.target.closest(SOURCE_SELECTOR) : null;
    if (source) scheduleSource(source);
  });
})();
